module.exports = __webpack_public_path__ + "static/img/p8-3.b8ee938.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p8-3.jpg
// module id = BAVs
// module chunks = 1